import {useTranslation} from "react-i18next";

import {CitySlug} from "../../../../../config/cities";
import {useAppSelector} from "../../../../../utils/hooks/store_hooks";
import {selectChartsSelectedRegion} from "../../../components/map/redux/map_city_poc_slice";

export interface ISelectedRegionDisplay {
    /** Same fallback as `useEffectiveCitySlug` — for API params, always a valid `CitySlug`. Only meaningful for text display when `isKnownCity` is true. */
    citySlug: CitySlug;
    /** True only when a region is actually selected and it maps to a known `CitySlug`. False both for unmatched regions (e.g. Pruszków) and when nothing is selected — callers must use `regionLabel` in that case, never `citySlug`, to avoid implying a city that isn't actually selected. */
    isKnownCity: boolean;
    /** Nominative, ready-to-display label: the selected region's own label, or a "pick a location" placeholder when nothing is selected. */
    regionLabel: string;
}

/** Text-display counterpart to `useEffectiveCitySlug`, surfacing what's actually picked in the map Autocomplete. */
export const useSelectedRegionDisplay = (): ISelectedRegionDisplay => {
    const chartsSelectedRegion = useAppSelector(selectChartsSelectedRegion);
    const {t} = useTranslation();

    const isKnownCity = chartsSelectedRegion != null && chartsSelectedRegion.citySlug != null;
    const citySlug = chartsSelectedRegion?.citySlug ?? CitySlug.WARSZAWA;
    const regionLabel = chartsSelectedRegion?.label ?? t("nav.choose_city");

    return {citySlug, isKnownCity, regionLabel};
};
